// extracted by mini-css-extract-plugin
module.exports = {"item":"InputCheck_item__bVyEH","option":"InputCheck_option__12zYx","checkmark":"InputCheck_checkmark__2SiOD","icon":"InputCheck_icon__1BnyC","title":"InputCheck_title__3JHWv"};